import { Fragment, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { BlockBody, BlockContainer, BlockHeader } from '@medifind/containers';
import { MFLink, Skeleton } from '@medifind/shared-basic-components';
import { getNullList, isPrerender } from '@medifind/utils';
import styles from './DoctorProfileAreasOfFocus.module.scss';

const DoctorProfileAreasOfFocus = ({ doctor, classes }) => {
  const { familyName, areasOfFocus } = doctor || {};
  const [showAreaOfFocus, setShowAreaOfFocus] = useState(isPrerender);
  const toggleAreaOfFocus = () => setShowAreaOfFocus(!showAreaOfFocus);

  return (
    <BlockContainer id="additionalAOF" className={classes.block}>
      <BlockHeader priority={2} className={classes.blockHeader}>
        Additional Areas of Focus
      </BlockHeader>
      <BlockBody className={classes.blockBody}>
        <Row>
          <Col>
            <p>
              {doctor ? familyName : <Skeleton width="50%" />} has provided the following conditions as areas of focus. Please note that we
              may not have enough data to validate their experience in some of these conditions.
            </p>
          </Col>
        </Row>
        <Row className={styles['aof']}>
          <Col md={12}>
            {showAreaOfFocus ? (
              <Row>
                <Col xl={6}>
                  {(areasOfFocus ? areasOfFocus.slice(0, Math.ceil(areasOfFocus.length / 2)) : getNullList(1)).map((l, i) => (
                    <Fragment key={'areasOfFocus-' + i}>
                      <div className={styles['aof-item']}>{l ? l : <Skeleton />}</div>
                    </Fragment>
                  ))}
                </Col>
                <Col xl={6}>
                  {(areasOfFocus ? areasOfFocus.slice(Math.ceil(areasOfFocus.length / 2)) : getNullList(1)).map((l, i) => (
                    <Fragment key={'areasOfFocus-' + i}>
                      <div className={styles['aof-item']}>{l ? l : <Skeleton />}</div>
                    </Fragment>
                  ))}
                </Col>
              </Row>
            ) : (
              <Row>
                <Col xl={6}>
                  {(areasOfFocus ? areasOfFocus.slice(0, 5) : getNullList(1)).map((l, i) => (
                    <Fragment key={'areasOfFocus-' + i}>
                      <div className={styles['aof-item']}>{l ? l : <Skeleton />}</div>
                    </Fragment>
                  ))}
                </Col>
                <Col xl={6}>
                  {(areasOfFocus ? areasOfFocus.slice(5, 10) : getNullList(1)).map((l, i) => (
                    <Fragment key={'areasOfFocus-' + i}>
                      <div className={styles['aof-item']}>{l ? l : <Skeleton />}</div>
                    </Fragment>
                  ))}
                </Col>
              </Row>
            )}
          </Col>
          <Col md={12}>
            {areasOfFocus?.length > 10 || !areasOfFocus ? (
              <>
                {areasOfFocus?.length > 10 ? (
                  <div className={styles['aof__view-more']}>
                    <MFLink className={styles['link']} onClick={toggleAreaOfFocus}>
                      View {areasOfFocus?.length - 10} {showAreaOfFocus ? 'Less' : 'More'} Areas of Focus
                      {showAreaOfFocus ? <span className={styles['plus']}>-</span> : <span className={styles['plus']}>+</span>}
                    </MFLink>
                  </div>
                ) : (
                  <Skeleton />
                )}
              </>
            ) : null}
          </Col>
        </Row>
      </BlockBody>
    </BlockContainer>
  );
};

export { DoctorProfileAreasOfFocus as default, DoctorProfileAreasOfFocus };
